<template>
    <div class="text-message-container">
        <div class="header-message">
            <p>Text Message ({{ templateOrder + 1 }}/3)</p>
            <div @click="removeMessageTemplate">
                <i class="bx bx-trash"></i>
            </div>
        </div>
        <div class="message-content">
          <ValidationProvider
            :rules="{
              required: {
                value: true,
                message: 'Please enter in text message',
              },
              max: {
                value: maxMessageCharacters,
              },
            }"
            v-slot="{ errors }"
          >
            <div class="grid-container" :data-replicated-value="textMessage">
              <textarea
                v-model="textMessage"
                :maxlength="maxMessageCharacters"
                placeholder="Type your message here..."
                @input="updateTextMessage"
                class="grid-textarea"
              ></textarea>
            </div>
            <div class="message-count">
              <p>
                <span class="current-char">{{ messageCharacterCounter }}</span>
                <span class="max-char">/{{ maxMessageCharacters }}</span>
              </p>
              <p class="error-message">
                {{ errors[0] }}
              </p>
            </div>
          </ValidationProvider>
        </div>
    </div>
</template>

<script>
import { debounce } from 'underscore';
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'TextMessage',
  components: {
    ValidationProvider,
  },
  props: {
    templateOrder: {
      type: Number,
      required: true,
    },
    copiedTextMessage: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      maxMessageCharacters: 500,
      textMessage: '',
    };
  },
  mounted() {
    if (this.copiedTextMessage && this.copiedTextMessage.trim().length > 0) {
      this.loadCopiedTextMessage();
    }
  },
  methods: {
    loadCopiedTextMessage() {
      this.textMessage = this.copiedTextMessage;
    },
    removeMessageTemplate() {
      this.$emit('remove-message-template');
    },
    updateTextMessage: debounce(function () {
      this.$emit('update-text-message', this.textMessage);
    }, 300),
  },
  computed: {
    messageCharacterCounter() {
      return this.textMessage.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-message-container{
    margin-top: 20px;
    border: 1px solid #DADCE4;
    border-radius: 8px;
    p{
        margin-bottom: 0px;
    }
    .header-message{
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #F5F6FA;
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: 0px;
        color: #0D173C;
        padding: 10px 16px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        border-bottom: 1px solid #DADCE4;
        i{
            font-size: 16px;
            color: #4B5178;
            cursor: pointer;
        }
    }
    .message-content{
        padding: 20px;
        .grid-container {
          display: grid;
          width: 100%;
          min-height: 150px;
          border: 1px solid #DADCE4;
          border-radius: 8px;
          overflow: hidden;
          margin-bottom: 10px;
        }

        .grid-container::after {
          content: attr(data-replicated-value) " ";
          white-space: pre-wrap;
          visibility: hidden;
          grid-area: 1 / 1 / 2 / 2;
          padding: 20px;
          min-height: 150px;
          box-sizing: border-box;
        }

        .grid-textarea {
          resize: none;
          overflow: hidden;
          grid-area: 1 / 1 / 2 / 2;
          padding: 12px;
          border: none;
          outline: none;
          box-sizing: border-box;
          background: transparent;
          font-size: 14px;
          line-height: 150%;
          color: #4B5178;
        }
        .message-count {
            p{
                color: #868BA6;
            }
            .current-char{
                font-weight: 500;
                font-size: 12px;
                line-height: 150%;
                letter-spacing: 0%;
            }
            .max-char{
                font-weight: 400;
                font-size: 12px;
                line-height: 150%;
                letter-spacing: 0%;
            }
            .error-message{
              font-weight: 400;
              font-size: 12px;
              line-height: 150%;
              letter-spacing: 0px;
              color: #EF6767;
              height: 18px;
              width: max-content;
              position: relative;
              top: -18px;
            }
            & .error-message {
              display: flex;
              justify-content: space-between !important;
            }
            :not(.error-message) {
              display: flex;
              justify-content: flex-end;
            }
        }
    }
}
</style>
